/** Tesouro Reserva rende 100% da Selic sem marcação a mercado: cadastro só com valor e data, sem PU nem taxa. */
export const TESOURO_RESERVA_TYPE = "RESERVA";

export const isTesouroReserva = (treasure?: { TrsrBdType?: { nm?: string } | null } | null): boolean =>
    treasure?.TrsrBdType?.nm === TESOURO_RESERVA_TYPE;
